import {
	EVENT_NEW_FORM,
	EVENT_LOGOUT
} from "constants.js";
import template from "./form-selector-modal.html";
import "./form-selector-modal.less";

//formSelectorModal
export function controller(appState, eventBus, $state, $scope, $logger) {
	const ctrl = this;

	ctrl.$onInit = onInit;
	ctrl.forms = appState.forms.items;
	ctrl.selected = appState.forms.selected;
	ctrl.handleClose = handleClose;
	ctrl.onFormSelected = onFormSelected;

	function onInit() {
		eventBus.register(
			EVENT_LOGOUT,
			() => {
				handleClose();
			},
			$scope
		);
	}

	function onFormSelected($event) {
		const selectedForm = $event.form;

		appState.forms.select(selectedForm)
			.then((selected) => {
				appState.clearSelectedEntity();
				
				if(selected === undefined) {
					navigateTo("authenticated.welcome");
				}
				else if(!$event.isFormUnchanged) {
					navigateTo("authenticated.dashboard");
				} 
				else {
					ctrl.modalInstance.close({ isFormUnchanged: true });
				}
			});
	}

	function navigateTo(state) {
		$state
			.go(
				state,
				{},
				{
					reload: true
				}
			)
			.then(() => {
				ctrl.modalInstance.close();
				eventBus.trigger(EVENT_NEW_FORM);
			})
			.catch(() => {
				ctrl.modalInstance.close();
			});
	}

	function handleClose() {
		ctrl.modalInstance.close();
	}
}

export default angular.module("vesl.components.form-selector-modal", []).component("formSelectorModal", {
	controller,
	template,
	bindings: {
		close: "&",
		dismiss: "&",
		modalInstance: "<",
		resolve: "<",
		getUsers: "&"
	}
}).name;
